var _use, _defs, _symbol;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.03 66.03",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 1.515,
    y: 1.515
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "89%",
    y1: "100%",
    x2: "11%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ed1c29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f37158"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "B",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.398.191L29.507 12.994 13.974 5.925c-.403-.191-.807-.191-1.009 0s-.403.573-.202.956l3.63 16.049L.66 29.999c-.404 0-.807.382-.607.956 0 .382.403.573.607.573l15.533 7.26-3.832 16.046c-.202.382 0 .765.202.956.403.191.807.191 1.009 0l15.533-6.878 10.891 12.803c.202.382.607.573 1.009.382s.607-.382.607-.765l3.832-16.049H62.79c.403.191.807 0 1.009-.573.202-.382 0-.765-.403-.956l-10.69-12.803 10.891-12.803c.202-.191.404-.573.404-.956-.202-.382-.607-.382-1.009-.382h-4.44c-.403 0-.607.191-.807.382L41.407 33.627c-.202.191-.202.191-.403.191s0-.191 0-.382l13.918-16.049v-.382c0-.191-.202-.191-.403-.191H48.87c-.403 0-.807.191-1.21.573l-16.135 16.24c-.404.382 0 .191-.202.191s0-.191 0-.382l13.716-15.667c.202-.191.403-.573.403-.956 0-.191-3.63-15.858-3.832-16.049 0-.382-.202-.765-.807-.765-.404 0-.807.191-.807.573",
    fillRule: "nonzero",
    stroke: "none",
    fill: "url(#A)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNab);
export default __webpack_public_path__ + "static/media/nab.914f8273988aea26061dd5cd13da0a60.svg";
export { ForwardRef as ReactComponent };